import { createAction, props } from '@ngrx/store';
import { CommunityProduct } from '../../models/community-product.model';

// Error payload structure for type safety
export interface ErrorPayload {
  message: string;  // Error message
  statusCode: number;  // HTTP or custom error code
}

// Action to load all products (no filters applied)
export const loadAllCommunityProducts = createAction(
  '[Product] Load All Products',
  props<{
    basedProduct?: any;
    page?: number;
    orderBy?: string;
    categoryId?: string;
    subRegionId?: any;
    limit?: number;
    isPopular?: boolean;
  }>()
);

// Action for successfully loading all products
export const loadAllCommunityProductsSuccess = createAction(
  '[Product] Load All Products Success',
  props<{ communityProducts: CommunityProduct[] }>()
);

// Action for failure while loading all products
export const loadAllCommunityProductsFailure = createAction(
  '[Product] Load All Products Failure',
  props<{ error: ErrorPayload }>()
);
